import { z } from "zod";
import { connectionClientSchema, connectionKindSchema } from "../api-keys.js";
/**
 * Who connected which AI app, and what it asked (DESIGN.md §14, "AI apps").
 * The Rust API answers in exactly these shapes (`server/crates/api/src/
 * modules/admin/ai_apps.rs` and `ai_apps_customer.rs`):
 * `GET /api/admin/ai-apps` and `GET /api/admin/customers/{id}/ai-apps`.
 */
export const adminAiAppsSchema = z.object({
    days: z.number().int(),
    /** People with at least one app reaching a workspace. */
    people: z.number().int(),
    connections: z.number().int(),
    /** People who made a call in the window. */
    activePeople: z.number().int(),
    calls: z.number().int(),
    reads: z.number().int(),
    changes: z.number().int(),
    /** When the app behind each call began to be recorded, inside the window. */
    countedFrom: z.string().nullable(),
    byApp: z.array(z.object({
        client: connectionClientSchema,
        connections: z.number().int(),
        people: z.number().int(),
        calls: z.number().int(),
        lastUsedAt: z.string().nullable(),
    })),
    tools: z.array(z.object({
        title: z.string(),
        reads: z.boolean(),
        calls: z.number().int(),
        people: z.number().int(),
    })),
    workspaces: z.array(z.object({
        workspaceId: z.string(),
        name: z.string(),
        connections: z.number().int(),
        people: z.number().int(),
        calls: z.number().int(),
    })),
});
export const customerAiAppSchema = z.object({
    id: z.string(),
    name: z.string(),
    client: connectionClientSchema,
    kind: connectionKindSchema,
    lastFour: z.string(),
    person: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
    /** Null is every brand the person sees here. */
    brands: z.number().int().nullable(),
    readOnly: z.boolean(),
    calls: z.number().int(),
    tools: z.array(z.object({ title: z.string(), calls: z.number().int() })),
});
export const customerAiAppsSchema = z.object({
    days: z.number().int(),
    /** Every MCP call made in this workspace in the window. */
    calls: z.number().int(),
    people: z.number().int(),
    countedFrom: z.string().nullable(),
    apps: z.array(customerAiAppSchema),
});
//# sourceMappingURL=ai-apps.js.map